import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';


//declare var _; Esempio con lodash
/*
  Da Mettere in index.html per importare lodash via cdn

<script type = "text/JavaScript" 
   src = "https://cdn.jsdelivr.net/npm/lodash@4.17.20/lodash.min.js" defer async>
</script>

*/

@Pipe({
  name: 'distinctArray',
  pure: true //se false ogni variazione del componente verrà aggiornata la pipe 
})


export class DistinctArrayPipe implements PipeTransform {

  
  transform(data: any, ...args: any) {

    
    
    if (typeof args == 'undefined') {
      return data
    }
    /* if(!Array.isArray(array)){
      return array
    } */
    
    let value:any;


    

    if(data['value'] !== undefined && data['value'] !== null){

      value = data['value'];

    }
    else if(args[0][2]){
      


      let dataField = (args[0][2] as string).toLowerCase().endsWith('desc') ? (args[0][2] as string).substring(0,(args[0][2] as string).length-4) :  (args[0][2] as string);
      


      let i = 0;

      if(Array.isArray(data['data'][`${dataField}`])){

        value = '';


        for(let obj of data['data'][`${dataField}`]){
  


          if(i==0)
            value += obj[`${args[0][0]}`];
          else
            value += ', ' + obj[`${args[0][0]}`];
            

          i++;

        }
  
  
      }

      return value;

    } 


    


    if (value !== undefined && value !== null) {
      let key
      let type = '';
      let items
      let valueExpr
      if (Array.isArray(args[0])) {
        key = args[0][0];
        type = args[0][1];
        items = args[0][2];
        valueExpr = args[0][3];
      } else {
        key = args[0]
      }

      if (type == 'getData') {

        if (items.length > 0) {
          let arrayRis = items.filter(item => item[valueExpr] == value)

          return arrayRis[0][key];
        }
      }


      if (type == 'map') {
        if(!Array.isArray(value)){
          return value
        }
        if(key && Object.keys(value[0]).some(propKey => propKey.toLowerCase() == key)){
          let arrayRis = value.map(item => {
            return item[key]
          });
          
          return arrayRis;
        
        }else{
          return Array.isArray(value)? value.toString() : null;
        }
        
        
      }

      let arrayRis = [...new Map(value.map(item =>
        [item[key], item])).values()];

      //console.warn('dopo',arrayRis);

      return arrayRis;
    }
    else
      return [];




    /*
     esempio con lodash


      return _.uniqBy(array, 'id');
    */


  }




}


